(function() {
  'use strict';

  var STORAGE_KEY = 'reia_click_attr';
  var COOKIE_NAME = '_reia_click_attr';
  var COOKIE_DAYS = 90; // matches Google Ads' max click-through conversion window
  var PUSHED_FLAG_KEY = 'reia_click_attr_pushed_fp';

  var TRACKED_PARAMS = [
    'gclid', 'gbraid', 'wbraid', // Google Ads click ids
    'fbclid',                     // Meta click id
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'
  ];

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax' + secure;
  }

  function getStored() {
    var raw = null;
    try { raw = window.localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (!raw) raw = readCookie(COOKIE_NAME);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function setStored(data) {
    var raw = JSON.stringify(data);
    try { window.localStorage.setItem(STORAGE_KEY, raw); } catch (e) {}
    writeCookie(COOKIE_NAME, raw, COOKIE_DAYS);
  }

  function captureFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    var hasAny = false;

    TRACKED_PARAMS.forEach(function(key) {
      var val = params.get(key);
      if (val) {
        found[key] = val;
        hasAny = true;
      }
    });

    if (!hasAny) return null;

    found.landing_page = window.location.pathname;
    found.click_ts = new Date().toISOString();
    return found;
  }

  function resolveAttribution() {
    var fromUrl = captureFromUrl();
    if (fromUrl) {
      // New click id / UTM set present — last-click wins, replaces any prior stored touch.
      setStored(fromUrl);
      return fromUrl;
    }
    // No tracking params on this pageview — keep whatever we already captured.
    return getStored();
  }

  function fingerprint(data) {
    return TRACKED_PARAMS.map(function(k) { return data[k] || ''; }).join('|') + '|' + (data.click_ts || '');
  }

  function pushToCartAttributes(data, opts) {
    opts = opts || {};
    var attributes = {};
    TRACKED_PARAMS.forEach(function(key) {
      if (data[key]) attributes[key] = data[key];
    });
    if (data.landing_page) attributes.click_landing_page = data.landing_page;
    if (data.click_ts) attributes.click_captured_at = data.click_ts;

    if (Object.keys(attributes).length === 0) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ attributes: attributes })
    }).then(function() {
      if (!opts.skipFingerprint) {
        try { window.sessionStorage.setItem(PUSHED_FLAG_KEY, fingerprint(data)); } catch (e) {}
      }
    }).catch(function() {
      // Best-effort — a failed push here just means this pageview's attempt is lost;
      // the next pageview (or the pre-checkout safety net) will retry.
    });
  }

  function alreadyPushed(data) {
    var fp = null;
    try { fp = window.sessionStorage.getItem(PUSHED_FLAG_KEY); } catch (e) {}
    return fp === fingerprint(data);
  }

  var attribution = resolveAttribution();
  if (attribution && !alreadyPushed(attribution)) {
    pushToCartAttributes(attribution);
  }

  // Safety net: re-push right before the customer heads into checkout, in case
  // they landed and clicked "Buy it now" faster than the pageview push completed,
  // or the cart didn't exist yet when this script first ran.
  document.addEventListener('click', function(evt) {
    var target = evt.target.closest(
      'a[href^="/checkout"], a[href*="/checkout"], button[name="checkout"], [data-checkout-button]'
    );
    if (!target) return;
    var current = getStored();
    if (current) pushToCartAttributes(current, { skipFingerprint: true });
  }, true);

  // Visitor's marketing consent from Shopify's Customer Privacy API:
  // 'yes' / 'no', or '' where no consent was asked (regions without a banner).
  // reia-booking-api maps this to Google's adUserData / adPersonalization
  // consent when it uploads offline lead conversions, and won't send the
  // lead's data to Google Ads at all on 'no'.
  function readMarketingConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return '';
    try {
      var consent = cp.currentVisitorConsent();
      return (consent && consent.marketing) || '';
    } catch (e) {
      return '';
    }
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function() {});
    } catch (e) {}
  }

  // Shared read access for every lead-capture form on the site (Chat/Callback,
  // appointment, franchise, shop-live) — they all attach this to their lead
  // payload's `metadata` so reia-booking-api can forward it for Google Ads
  // lead-conversion reporting, the same way cart attributes do for orders.
  window.reiaGetClickAttribution = function() {
    var data = getStored();
    var marketing = readMarketingConsent();
    if (!marketing) return data;
    var out = {};
    if (data) for (var k in data) out[k] = data[k];
    out.consent_marketing = marketing;
    return out;
  };
})();
